<template>
    <div class="form-element flex mb-2" :class="layoutClasses">
        <Label :id="id" :required="required" :label="label" v-if="label" />
        <div class="form-field-wrapper">
            <select
                :id="id"
                :name="name"
                :multiple="multiple"
                :required="required"
                :disabled="disabled"
                :readonly="readonly"
                @change="onInput"
                ref="select"
                class="form-field flex-1 w-full pr-[35px] border border-gray-300 rounded-md focus:outline-none focus:ring-0 focus:border-blue-dark-500"
                :class="{ 'border-red-600': error }"
            >
                <option v-if="emptyOption"></option>
                <option
                    v-for="(option, key) of sortedOptions"
                    :value="option[0]"
                    :selected="Array.isArray(modelValue) ? modelValue.includes(option[0]) : modelValue == option[0]"
                >
                    {{ option[1]}}
                </option>
            </select>
            <Error :error="error" v-if="error" />
        </div>
    </div>
</template>

<script>
import Label from "./Label"
import Error from "./Error"
import Input from './Input.vue'

import {watch, onMounted} from "vue";

export default {
    components: {
        Label,
        Error,
        Input,
    },
    emits: ['update:modelValue'],
    props: {
        layout: {
            type: String,
            default: 'horizontal',//vertical
        },
        label: {
            type: String,
        },
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            default: (props) => props.name,
        },
        modelValue: {
            type: [String, Number, Array]
        },
        required: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        },
        emptyOption: {
            type: Boolean,
            default: false
        },
        error: {
            type: String
        },
        options: {
            type: Object,
            required: true,
        },
        sortByLabel: {
            type: Boolean,
            default: true
        }
    },
    setup (props, { emit }) {
        let sortedOptions = []

        sortOptions(props.options)

        function sortOptions(options)
        {
            sortedOptions.length = 0;
            for (let option in options)
            {
                sortedOptions.push([option, options[option]]);
            }

            if (props.sortByLabel)
            {
                sortedOptions.sort(function(a, b) {

                    if (a[1].toString().toLowerCase() < b[1].toString().toLowerCase())
                    {
                        return -1
                    }

                    return 0
                });
            }
        }

        function onInput(event)
        {
            if (props.multiple)
            {
                emit('update:modelValue', Array.from(event.target.selectedOptions).map(option => option.value))
            }
            else
            {
                emit('update:modelValue', event.target.value)
            }
        }

        onMounted(() => {

            // Initialize modelValue with the first option if it's null
            // Get the default selected option, so the first one
            if (props.modelValue === null && !props.emptyOption && sortedOptions.length > 0) {
                emit('update:modelValue', sortedOptions[0][0]);// When there's no empty option, the first option in the list should be set as modelValue and passed to the parent component
            }
        });

        // Watch modelValue and reselect first option if modelValue is null
        //We use this on initialization, also after a submit when the form has been reset but the component is alread rendered
        watch(
            () => props.modelValue,
            (newValue) => {
                if (newValue === null && !props.emptyOption && sortedOptions.length > 0) {
                    emit('update:modelValue', sortedOptions[0][0]);
                }
            }
        );

        watch(() => props.options, (currentOptions, oldOptions) => {
            sortOptions(currentOptions)
        })

        return {
            sortedOptions,
            onInput,
        }
    },
    computed: {
        layoutClasses() {
            if (this.layout == 'vertical') {
                return 'flex-col';
            } else {
                return 'items-start';
            }
        }
    },
}
</script>
